import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={200}
    height={200}
    className="icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="m469.333 7.85-2.73-3.754L463.872 0h-194.56l10.581 15.019 10.24 13.994 284.672 402.091a140.63 140.63 0 0 1 0 161.792l-284.672 402.09-10.24 13.995L269.312 1024h194.219l3.072-4.096 2.73-3.755L696.32 695.637a318.123 318.123 0 0 0 0-367.274z"
    />
  </svg>
);
export default SvgComponent;
